import AssetGroupView from './AssetGroupView';

const views = {
  AssetGroupView,
};
export default views;
